<script>
import BaseRadioButton from '@/components/_base-radio-button.vue'

export default {
  name: 'ExportWhat',
  components: {
    BaseRadioButton,
  },
  props: {
    /**
     * v-model binding for selected export type
     * 'filtered' | 'all'
     */
    modelValue: {
      type: String,
      default: 'filtered',
    },
    /**
     * Pass in true when exportMode !== 'selected'
     * to switch labels between "Export what" and "Export with"
     */
    isSelectedMode: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue'],
}
</script>

<template>
  <div>
    <label class="section-label">
      {{
        isSelectedMode
          ? $t('exportBookings.exportWith.label')
          : $t('exportBookings.exportWhat.label')
      }}
    </label>
    <div class="radio-group">
      <BaseRadioButton
        :model-value="modelValue"
        :value="'filtered'"
        name="exportType"
        label-color="black"
        @update:modelValue="$emit('update:modelValue', $event)"
      >
        <span class="radio-label">
          {{
            isSelectedMode
              ? $t('exportBookings.exportWith.filtered')
              : $t('exportBookings.exportWhat.filtered')
          }}
        </span>
      </BaseRadioButton>
      <BaseRadioButton
        :model-value="modelValue"
        :value="'all'"
        name="exportType"
        label-color="black"
        @update:modelValue="$emit('update:modelValue', $event)"
      >
        <span class="radio-label">
          {{
            isSelectedMode
              ? $t('exportBookings.exportWith.all')
              : $t('exportBookings.exportWhat.all')
          }}
        </span>
      </BaseRadioButton>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/_colors.scss';
@import '@/styles/bookingList/booking-export.scss';
</style>
